export default "__VITE_ASSET__e50cc7d4__"